<app-base-page-template pageTitle="Terms of Service">
  <app-base-page-content-template>
    <app-pdf-viewer
      [pdfSrc]="'/assets/files/terms-of-service.pdf'">
    </app-pdf-viewer>
  </app-base-page-content-template>
</app-base-page-template>

